import * as LucideIcons from "lucide-vue-next";

const iconMap: Record<string, string> = {
  group: "Users",
  house: "Home",
  data_array: "Database",
  key: "Key",
  settings: "Settings",
  other_houses: "Building2",
  database: "Database",
  school: "GraduationCap",
  get_app: "Download",
  logout: "LogOut",
  menu: "Menu",
  home: "Home",
  login: "LogIn",
  close: "X",
  person_add: "UserPlus",
  mail: "Mail",
  chat: "MessageSquare",
  folder: "Folder",
  article: "FileText",
  event: "Calendar",
  favorite: "Heart",
  favorite_border: "Heart",
  note: "StickyNote",
  add_circle_outline: "PlusCircle",
  description: "FileText",
  schedule_send: "Clock",
  history: "History",
  edit_note: "Edit",
  forum: "MessageCircle",
  settings_suggest: "Settings",
  data_object: "Braces",
  // Top-level module group icons
  book: "BookOpen",
  account_tree: "Workflow",
  psychology: "Brain",
  work: "Briefcase",
  credit_card: "CreditCard",
  view_list: "List",
  public: "Globe",
  smart_toy: "Bot",
  // Pipeline / scholar item icons referenced by module nav configs
  play_circle: "PlayCircle",
  price_change: "DollarSign",
  monitoring: "Activity",
  folder_open: "FolderOpen",
  menu_book: "BookMarked",
  storefront: "Store",
  image: "Image",
  checklist: "ListChecks",
  admin_panel_settings: "ShieldCheck",
  rule: "Scale",
  engineering: "Wrench",
  scatter_plot: "ScatterChart",
};

export function getIconComponent(iconName?: string) {
  if (!iconName) return LucideIcons.Circle;
  const lucideIconName = iconMap[iconName] || "Circle";
  return (
    (LucideIcons as Record<string, unknown>)[lucideIconName] ||
    LucideIcons.Circle
  );
}
